import { returnDetail } from '@root/state/reducers/return_disposal/returnDisposalReducer';
import { Form, Input, Row } from 'antd';
import { useEffect, useMemo, useState } from 'react';

interface returnQuantity {
  productId: number;
  productName: string;
  returnQuantity: number;
}
function RecipientForm({
  edit,
  detailData,
  returnQuantities,
  returnQuantityStock,
  form
}: {
  edit?: boolean;
  detailData: returnDetail;
  returnQuantities?: returnQuantity[];
  returnQuantityStock?: returnQuantity;
  form?: any;
}) {
  const isEdit = !edit;
  const defaultValue = useMemo(() => {
    return {
      recipientName: detailData ? detailData?.recipientName : '',
      recipientPhone: detailData ? detailData?.recipientPhone : '',
      sellerComment: detailData ? detailData?.comment : '',
      returnAddress: detailData ? detailData?.returnAddress : '',
      detailReturnAddress: detailData ? detailData?.detailReturnAddress : '',
      detailReturnAddress2: detailData ? detailData?.detailReturnAddress2 : '',
      postalCode: detailData ? detailData?.postalCode : '',
      country: detailData ? detailData?.country : '',
      city: detailData ? detailData?.city : '',
      state: detailData ? detailData?.state : '',
      returnQuantities: returnQuantities
        ? returnQuantities?.map((returnQuantities) => {
            return {
              returnQuantity: returnQuantities.returnQuantity
            };
          })
        : '',
      returnReason: detailData ? detailData?.returnReason : '',
      returnQuantityStock: returnQuantityStock?.returnQuantity
        ? returnQuantityStock?.returnQuantity
        : ''
    };
  }, [detailData, returnQuantities]);

  useEffect(() => {
    if (form) {
      form.setFieldsValue(defaultValue);
    }
  }, [form, defaultValue]);

  useEffect(() => {
    if (form) {
      form.setFieldsValue(returnQuantities);
    }
  }, [form, returnQuantities]);

  return (
    detailData && detailData.id ?
    <Form
      form={form}
      initialValues={{
        recipientName: defaultValue.recipientName,
        recipientPhone: defaultValue.recipientPhone,
        sellerComment: defaultValue.sellerComment,
        returnAddress: defaultValue.returnAddress,
        detailReturnAddress: defaultValue.detailReturnAddress,
        postalCode: defaultValue.postalCode,
        country: defaultValue.country,
        returnQuantities: defaultValue.returnQuantities,
        returnReason: defaultValue.returnReason,
        returnQuantityStock: defaultValue.returnQuantityStock
      }}
    >
      <Form.Item
        style={{
          display: 'inline-block',
          width: '45%',
          marginRight: '30px'
        }}
      >
        <Form.Item
          label="Recipient Name"
          name="recipientName"
          style={{
            display: 'inline-block',
            width: '40%',
            marginRight: '30px'
          }}
        >
          <Input className="inputRadious" disabled={isEdit} />
        </Form.Item>
        <Form.Item
          label="Recipient Phone Number"
          name="recipientPhone"
          style={{
            display: 'inline-block',
            width: '50%'
          }}
        >
          <Input className="inputRadious" disabled={isEdit} />
        </Form.Item>
        <Form.Item
          style={{
            display: 'inline-block',
            width: '94%',
            marginTop: '20px'
          }}
          label="Comment from Seller"
        >
          <Form.Item name="sellerComment">
            <Input.TextArea
              style={{ resize: 'none' }}
              disabled={isEdit}
              className="inputRadious"
              rows={6}
            />
          </Form.Item>
        </Form.Item>
      </Form.Item>
      <Form.Item style={{ display: 'inline-block', width: 'calc(55% - 30px)' }}>
        <Form.Item
          label="Shipping Country/Address"
          name="country"
          style={{ display: 'inline-block', width: '35%' }}
        >
          <Input className="inputRadious" disabled={isEdit} />
        </Form.Item>
        <Form.Item
          name="detailReturnAddress"
          style={{
            display: 'inline-block',
            width: '65%',
            marginTop: '32px',
            paddingLeft: '10px'
          }}
        >
          <Input className="inputRadious" disabled={isEdit} />
        </Form.Item>
        <Form.Item
          name="detailReturnAddress2"
          style={{ display: 'inline-block', width: '50%', marginTop: '10px' }}
        >
          <Input className="inputRadious" disabled={isEdit} />
        </Form.Item>
        <Form.Item
          name="detailReturnAddress"
          style={{
            display: 'inline-block',
            width: '50%',
            marginTop: '10px',
            paddingLeft: '10px'
          }}
        >
          <Input className="inputRadious" disabled={isEdit} />
        </Form.Item>
        <Form.Item style={{ marginTop: '10px' }}>
          <Form.Item
            name="city"
            style={{
              display: 'inline-block',
              width: '33%',
              paddingRight: '10px'
            }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
          <Form.Item
            name="state"
            style={{
              display: 'inline-block',
              width: '34%',
              paddingRight: '10px'
            }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
          <Form.Item
            name="postalCode"
            style={{
              display: 'inline-block',
              width: '33%'
            }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
        </Form.Item>
        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {detailData?.importProducts?.returnQuantity &&
              detailData?.importProducts?.returnQuantity?.map(
                (returnQuantity, index: number) => (
                  <Form.Item
                    key={index}
                    name={[index, 'returnQuantity']}
                    style={{
                      display: 'inline-block',
                      marginTop: '15px',
                      marginRight: '30px',
                      width: '70%'
                    }}
                    label="Quantity "
                  >
                    <Input className="inputRadious" disabled={isEdit} />
                  </Form.Item>
                )
              )}

            {returnQuantityStock && (
              <Form.Item
                name={'returnQuantityStock'}
                style={{
                  display: 'inline-block',
                  marginTop: '15px',
                  marginRight: '30px',
                  width: '70%'
                }}
                label="Quantity "
              >
                <Input className="inputRadious" disabled={isEdit} />
              </Form.Item>
            )}
          </div>
          <Form.Item
            label="Reason for return/disposal "
            name="returnReason"
            style={{ display: 'inline-block', width: '40%', marginTop: '15px' }}
          >
            <Input className="inputRadious" disabled={isEdit} />
          </Form.Item>
        </div>
      </Form.Item>
    </Form> : <></>
  );
}

export default RecipientForm;
